// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2pMPN","icon":"SortAdornment_icon__14Oss","up":"SortAdornment_up__1hdpD","down":"SortAdornment_down__3nI7I","active":"SortAdornment_active__3edUB"};